import toast, { ToastBar, Toaster, ToasterProps } from "react-hot-toast";

import { Icon, SemanticICONS } from "semantic-ui-react";
import { styled } from "styled-components";

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  .icon-container {
    margin-right: 10px;
  }
  .info-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 19px;
    max-width: 270px;
    span {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }
  .meta {
    color: gray;
  }
  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 5px;
  right: 2.5px;
  cursor: pointer;
  color: gray;
`;

const ToastIcon = ({ name }: { name: SemanticICONS }) => (
  <Icon name={name} size="large" />
);

const CustomToaster = (props: ToasterProps) => (
  <Toaster {...props}>
    {(t) => (
      <ToastBar toast={t}>
        {({ icon, message }) => (
          <>
            {icon}
            {message}
            {t.type !== "loading" ?
              <>
                <div style={{ width: 5 }} />
                <StyledIcon
                  onClick={() => toast.dismiss(t.id)}
                  name="close"
                  size="small"
                />
              </>
            : null}
          </>
        )}
      </ToastBar>
    )}
  </Toaster>
);

export { ToastContainer, ToastIcon, CustomToaster as Toaster };
